import { useMutation, UseMutationResult } from 'react-query';

import { getTokenWithType } from './useAuth';

import { twilioInfoSave } from '../utils/urls';

import { TwilioDetails } from 'types/countryType';
import { ErrorModal } from 'types/modalTypes';

export async function saveTwilioInfo(params: TwilioDetails): Promise<TResult> {
  const response = await fetch(twilioInfoSave(params.AccountId), {
    method: 'PUT',
    headers: {
      Authorization: getTokenWithType(),
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(params),
  });
  if (response.status !== 200) {
    const errorText = await response.text();
    const errorCode = await response.status;
    throw { message: errorText, code: errorCode };
  }
  return response.json();
}

type TError = ErrorModal;

type TResult = {
  Data: string;
  IsSuccess: boolean;
  StatusCode: number;
};

type TVariables = any;

type TSnapshot = unknown;

function useSaveTwilioInfo(): UseMutationResult<
  TResult,
  TError,
  TVariables,
  TSnapshot
> {
  return useMutation(async (params: TwilioDetails) => {
    const renamedResult = await saveTwilioInfo(params);
    return renamedResult;
  });
}

export { useSaveTwilioInfo };
